export default __webpack_public_path__ + "static/eugene-f4c365f71691ec0d3c757f32b381f9d6.webp";